import { Button } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Paths } from '../../../shared/constants/paths';

const AlignRight = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 20px;
`;

interface RelatedProjectsLinkProps {
  id: string;
  variableName: string;
  array?: boolean;
}

export const RelatedProjectsLink: FC<RelatedProjectsLinkProps> = ({ id, variableName, array }) => {
  const variableValue = array ? `["${id}"]` : `"${id}"`;

  return (
    <AlignRight>
      <Link to={`${Paths.PROJECTS}?dataGridVars={"${variableName}": ${variableValue}}`}>
        <Button>Verknüpfte Projekte</Button>
      </Link>
    </AlignRight>
  );
};
